import React from 'react'

export default function Menu({surveys, setStatus, status}) {
  const getSelectedFilterStyle = st => {
    if (st === status) {
      return {backgroundColor: '#EDE7F6'}
    }
    return {color: '', backgroundColor: '#fff'}
  }

  return (
    <ul style={{cursor: 'pointer'}}>
      <li style={getSelectedFilterStyle('')} onClick={x => setStatus('')}>
        All Surveys
        <span>{surveys?.length}</span>
      </li>
      <li
        style={getSelectedFilterStyle('Live')}
        onClick={() => setStatus('Live')}
      >
        Live Surveys
        <span>{surveys?.filter(x => x.status === 'Live').length}</span>
      </li>
      <li
        style={getSelectedFilterStyle('Draft')}
        onClick={x => setStatus('Draft')}
      >
        Draft Surveys
        <span>{surveys?.filter(x => x.status === 'Draft').length}</span>
      </li>
      <li
        style={getSelectedFilterStyle('Published')}
        onClick={x => setStatus('Published')}
      >
        Published Surveys
        <span>{surveys?.filter(x => x.status === 'Published').length}</span>
      </li>
      <li
        style={getSelectedFilterStyle('Closed')}
        onClick={x => setStatus('Closed')}
      >
        Closed Surveys
        <span>{surveys?.filter(x => x.status === 'Closed').length}</span>
      </li>
    </ul>
  )
}
